import {createRouter, createWebHistory} from 'vue-router';
import WebListPage from './pages/WebList.vue';
import FeedbackPage from './pages/FeedbackPage.vue';
import CreateFeedbackPage from './pages/CreateFeedbackPage.vue';
import ChatPage from './pages/ChatPage.vue';
import ReferCodePage from './pages/ReferCodePage.vue';
import ReferenceRecordPage from './pages/ReferenceRecordPage.vue';
import AboutPage from './pages/AboutPage.vue';
import FaqPage from './pages/FaqPage.vue';
import PaymentPage from './pages/PaymentPage.vue';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{path: '/', component: WebListPage, name: 'webList'},
		{path: '/weblist', component: WebListPage, name: 'webList'},
		{path: '/payment', component: PaymentPage, name: 'PaymentPage'},
		{path: '/feedback', component: FeedbackPage, name: 'feedback'},
		{path: '/createFeedback', component: CreateFeedbackPage, name: 'createFeedback'},
		{path: '/chat', component: ChatPage, name: 'chat'},
		{path: '/referCodePage', component: ReferCodePage, name: 'referCodePage'},
		{path: '/referenceRecord', component: ReferenceRecordPage, name: 'referenceRecord'},
		{path: '/about', component: AboutPage, name: 'about'},
		{path: '/faq', component: FaqPage, name: 'faq'},
		{
			path: '/:pathMatch(.*)*',
			redirect: '/' // 重定向到默认路径
		}
	]
});

export default router;